import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core'
import { AppointmentDate } from '../../../modules/appointment/appointment.types'
import { getCurrentLocale } from '../../i18n/i18n.utils'

@Component({
  selector: 'drr-date-grid',
  templateUrl: './date-grid.component.html',
  styleUrls: ['./date-grid.component.scss'],
})
export class DateGridComponent implements OnChanges {
  @Input() days: AppointmentDate[] = []
  @Input() selectedDay: AppointmentDate = null
  @Output() selectedDayChange = new EventEmitter<AppointmentDate>()

  selectedDayIndex: number = -1

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDay'] && this.selectedDay) {
      this.selectedDayIndex = this.days.findIndex(day =>
        day.date.getTime() === this.selectedDay.date.getTime()
      )
    }
  }

  selectDay(index: number): void {
    this.selectedDayIndex = index
    const selectedDay = this.days[index]
    this.selectedDayChange.emit(selectedDay)
  }

  getDayLabel(date: Date): string {
    const locale = getCurrentLocale().locale

    const today = new Date()
    if (date.toDateString() === today.toDateString()) return $localize`Today`

    const tomorrow = new Date(today)
    tomorrow.setDate(today.getDate() + 1)
    if (date.toDateString() === tomorrow.toDateString()) return $localize`Tomorrow`

    return date.toLocaleDateString(locale, { weekday: 'long' })
  }
}
